module.exports = isThunk

function isThunk(t) {
    return t && t.type === "Thunk"
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/~/vtree/is-thunk.js
// module id = 198
// module chunks = 0